var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.00009L11.4545 3.45463V5.36372H5.72727V6.63645H11.4545V8.54554M0 9.81827V2.18191C0 1.47554 0.572727 0.90918 1.27273 0.90918H8.90909C9.24664 0.90918 9.57036 1.04327 9.80904 1.28195C10.0477 1.52064 10.1818 1.84436 10.1818 2.18191V4.091H8.90909V2.18191H1.27273V9.81827H8.90909V7.90918H10.1818V9.81827C10.1818 10.1558 10.0477 10.4795 9.80904 10.7182C9.57036 10.9569 9.24664 11.091 8.90909 11.091H1.27273C0.935179 11.091 0.611456 10.9569 0.372773 10.7182C0.134091 10.4795 0 10.1558 0 9.81827Z",
    fill: "#537C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.074936ec2a3036eb388f2fdcc2acaf99.svg";
export { ForwardRef as ReactComponent };